import { SocketService } from "@/services";
import { useMutation } from "react-query";

const useSendNoticeToDatalake = () => {
  const handleSendNoticeSuccess = () => {};

  const handleSendNoticeFailed = () => {};

  return useMutation<any, unknown>({
    mutationFn: () => SocketService.sendNoticeToDatalake(),
    onSuccess: handleSendNoticeSuccess,
    onError: handleSendNoticeFailed,
  });
};

export default useSendNoticeToDatalake;
